import {
    TERM_LIST_REQUEST,
    TERM_LIST_SUCCESS,
    TERM_LIST_FAIL,
} from '../constants/TermListConstants'
import api from '../core/api'

export const listTermList = () => async (dispatch, getState) => {
    try {
        dispatch({
            type: TERM_LIST_REQUEST
        })
        const { data } = await api.get(
            "/accounts/termlist"
        );

        dispatch({
            type: TERM_LIST_SUCCESS,
            payload: data.Result
        })
    }
    catch (error) {
        dispatch({
            type: TERM_LIST_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        })
    }
}